// extracted by mini-css-extract-plugin
module.exports = {"container":"WhatOurClientsSay_container__2K9Oi","spacerTop":"WhatOurClientsSay_spacerTop__3B6bL","spacerBottom":"WhatOurClientsSay_spacerBottom__22iim"};